import { render, staticRenderFns } from "./SpinnerSvg.vue?vue&type=template&id=3e75b3a4"
import script from "./SpinnerSvg.vue?vue&type=script&lang=js"
export * from "./SpinnerSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports